import React, { useState } from "react";
import { useLanguage } from "../../context/LanguageContext";

/**
 * Reusable Part Selector Component
 * Used in Equipment and Templates to add parts
 */
const PartSelector = ({ parts, onAdd, existingParts = [] }) => {
  const { t } = useLanguage();
  const [currentPart, setCurrentPart] = useState({
    part_id: "",
    quantity_needed: 1,
    notes: "",
  });

  const handleAdd = () => {
    if (!currentPart.part_id) {
      alert(t("partSelector.pleaseSelectPart"));
      return;
    }

    if (!currentPart.quantity_needed || currentPart.quantity_needed <= 0) {
      alert(t("partSelector.pleaseEnterValidQuantity"));
      return;
    }

    const part = parts.find((p) => p.id === parseInt(currentPart.part_id));

    // Check stock
    if (part && part.quantity < parseInt(currentPart.quantity_needed)) {
      alert(
        t("partSelector.insufficientStock", {
          available: part.quantity,
          needed: currentPart.quantity_needed,
        }),
      );
      return;
    }

    // Check if already added
    const exists = existingParts.find(
      (p) => p.part_id === parseInt(currentPart.part_id),
    );
    if (exists) {
      alert(t("partSelector.partAlreadyAdded"));
      return;
    }

    const newPart = {
      id: parseInt(currentPart.part_id),
      part_id: parseInt(currentPart.part_id),
      quantity: parseInt(currentPart.quantity_needed),
      notes: currentPart.notes,
      part_name: part?.name,
      part_color: part?.color,
      part_sku: part?.sku,
    };

    onAdd(newPart);
    setCurrentPart({ part_id: "", quantity_needed: 1, notes: "" });
  };

  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <div className="grid grid-cols-4 gap-3 mb-3">
        <select
          value={currentPart.part_id}
          onChange={(e) =>
            setCurrentPart({ ...currentPart, part_id: e.target.value })
          }
          className="input-field col-span-2"
        >
          <option value="">{t("partSelector.selectPart")}</option>
          {parts.map((part) => (
            <option key={part.id} value={part.id}>
              {part.name} {part.color ? `(${part.color})` : ""} -{" "}
              {t("partSelector.stock")}:{" "}
              {part.quantity || 0}
            </option>
          ))}
        </select>
        <input
          type="number"
          value={currentPart.quantity_needed}
          onChange={(e) =>
            setCurrentPart({ ...currentPart, quantity_needed: e.target.value })
          }
          className="input-field"
          placeholder={t("partSelector.qty")}
          min="1"
        />
        <button type="button" onClick={handleAdd} className="btn-success">
          {t("common.add")}
        </button>
      </div>
      <input
        type="text"
        value={currentPart.notes}
        onChange={(e) =>
          setCurrentPart({ ...currentPart, notes: e.target.value })
        }
        className="input-field"
        placeholder={t("partSelector.notesOptional")}
      />
    </div>
  );
};

export default PartSelector;
